import { avatarFor, blueOf, redOf, type Fixture } from '../lib/fighters'

export function BoutRow({
  fixture,
  children,
}: {
  fixture: Fixture
  children?: React.ReactNode
}) {
  const red = redOf(fixture)
  const blue = blueOf(fixture)
  return (
    <div className="bout">
      <div className="corner red">
        <img
          className="avatar fighter-cutout"
          src={avatarFor(red.id, red.image)}
          alt={red.name}
          onError={(e) => {
            ;(e.target as HTMLImageElement).src = '/assets/avatars/fighter-red.png'
          }}
        />
        <div>
          <div className="name">{red.name}</div>
          {red.nickname && <div className="nick">“{red.nickname}”</div>}
          {red.record && <div className="record">{red.record}</div>}
        </div>
      </div>
      <div className="mid">
        {fixture.billing && <div className="billing">{fixture.billing}</div>}
        <div className="vs">VS</div>
        <div className="weight">
          {fixture.weightClass || fixture.title}
          {fixture.rounds ? ` · ${fixture.rounds}R` : ''}
        </div>
      </div>
      <div className="corner blue">
        <img
          className="avatar fighter-cutout"
          src={avatarFor(blue.id, blue.image)}
          alt={blue.name}
          onError={(e) => {
            ;(e.target as HTMLImageElement).src = '/assets/avatars/fighter-green.png'
          }}
        />
        <div>
          <div className="name">{blue.name}</div>
          {blue.nickname && <div className="nick">“{blue.nickname}”</div>}
          {blue.record && <div className="record">{blue.record}</div>}
        </div>
      </div>
      {children}
    </div>
  )
}
